import { Form, Input } from "antd"
import { BULK_WALLET_LIMITS, parseBulkWalletAmount } from "./orderForm"

export const BulkWalletAmountField = () => (
  <Form.Item
    label="充值金额（元）"
    name="rechargeAmountYuan"
    preserve={false}
    dependencies={["purchaseUnitPrice"]}
    extra="按实际收款金额填写，最多两位小数。"
    rules={[
      { required: true, whitespace: true, message: "请输入充值金额" },
      ({ getFieldValue }) => ({
        validator(_, value) {
          const amount = parseBulkWalletAmount(value)
          if (amount === undefined)
            return Promise.reject(new Error("充值金额须大于 0，且最多两位小数"))
          const price = getFieldValue("purchaseUnitPrice")
          if (
            typeof price === "number" &&
            price > 0 &&
            amount > BULK_WALLET_LIMITS.quantity.max * price
          )
            return Promise.reject(new Error("到账积点数量不能超过 100000"))
          return Promise.resolve()
        },
      }),
    ]}
  >
    <Input
      inputMode="decimal"
      placeholder="请输入实际收款金额，如 100.00"
      suffix="元"
    />
  </Form.Item>
)
